import { ratingClasses, ratingFromScore, ratingShort, type Rating } from "../lib/rating";

interface Props {
  score: number | null | undefined;
  size?: "sm" | "md";
  /** When true, render the abbreviated form (S.BUY etc) — better for narrow chips. */
  short?: boolean;
}

export default function RatingBadge({ score, size = "sm", short = false }: Props) {
  const r: Rating | null = ratingFromScore(score);
  if (r === null) return null;
  const padding = size === "md" ? "px-2 py-0.5 text-[11px]" : "px-1.5 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold uppercase tracking-wide ring-1 ring-inset ${padding} ${ratingClasses(r)}`}
      title={`${r} (composite ${score?.toFixed(0) ?? "—"} / 100)`}
    >
      {short ? ratingShort(r) : r}
    </span>
  );
}
